export const languageOptions = [
  { label: 'Afrikaans', value: 'Afrikaans' },
  { label: 'Albanian', value: 'Albanian' },
  {
    label: 'American Sign Language (ASL)',
    value: 'American Sign Language (ASL)',
  },
  { label: 'Amharic', value: 'Amharic' },
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Armenian', value: 'Armenian' },
  { label: 'Bambara', value: 'Bambara' },
  { label: 'Bengali', value: 'Bengali' },
  { label: 'Bosnian', value: 'Bosnian' },
  { label: 'Bulgarian', value: 'Bulgarian' },
  { label: 'Burmese', value: 'Burmese' },
  { label: 'Cantonese', value: 'Cantonese' },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'Chinese (Cantonese)', value: 'Chinese (Cantonese)' },
  { label: 'Chinese (Mandarin)', value: 'Chinese (Mandarin)' },
  { label: 'Creole', value: 'Creole' },
  { label: 'Croatian', value: 'Croatian' },
  { label: 'Danish', value: 'Danish' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'English', value: 'English' },
  { label: 'Farsi', value: 'Farsi' },
  { label: 'Filipino', value: 'Filipino' },
  { label: 'Finnish', value: 'Finnish' },
  { label: 'French', value: 'French' },
  { label: 'Georgian', value: 'Georgian' },
  { label: 'German', value: 'German' },
  { label: 'Greek', value: 'Greek' },
  { label: 'Gujarati', value: 'Gujarati' },
  { label: 'Gujarti', value: 'Gujarti' },
  { label: 'Haitian Creole', value: 'Haitian Creole' },
  { label: 'Haitian Kreyol', value: 'Haitian Kreyol' },
  { label: 'Hebrew', value: 'Hebrew' },
  { label: 'Hindi', value: 'Hindi' },
  { label: 'Hmong', value: 'Hmong' },
  { label: 'Hungarian', value: 'Hungarian' },
  { label: 'Igbo', value: 'Igbo' },
  { label: 'Indian (Hindi)', value: 'Indian (Hindi)' },
  { label: 'Indian (Punjabi)', value: 'Indian (Punjabi)' },
  { label: 'Indonesian', value: 'Indonesian' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Kannada', value: 'Kannada' },
  { label: 'Kashmiri', value: 'Kashmiri' },
  { label: 'Korean', value: 'Korean' },
  { label: 'Konkani', value: 'Konkani' },
  { label: 'Kurdish', value: 'Kurdish' },
  { label: 'Lithuanian', value: 'Lithuanian' },
  { label: 'Macedonian', value: 'Macedonian' },
  { label: 'Malay', value: 'Malay' },
  { label: 'Malayalam', value: 'Malayalam' },
  { label: 'Mandarin', value: 'Mandarin' },
  { label: 'Marathi', value: 'Marathi' },
  { label: 'Nepali', value: 'Nepali' },
  { label: 'Norwegian', value: 'Norwegian' },
  { label: 'Pashto', value: 'Pashto' },
  { label: 'Persian', value: 'Persian' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Punjabi', value: 'Punjabi' },
  { label: 'Romanian', value: 'Romanian' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Serbian', value: 'Serbian' },
  { label: 'Serbo-Croatian', value: 'Serbo-Croatian' },
  { label: 'Shanghainese', value: 'Shanghainese' },
  { label: 'Sindhi', value: 'Sindhi' },
  { label: 'Slovak', value: 'Slovak' },
  { label: 'Slovenian', value: 'Slovenian' },
  { label: 'Somali', value: 'Somali' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'Swahili', value: 'Swahili' },
  { label: 'Swedish', value: 'Swedish' },
  { label: 'Tagalog', value: 'Tagalog' },
  { label: 'Taiwanese', value: 'Taiwanese' },
  { label: 'Tamil', value: 'Tamil' },
  { label: 'Telugu', value: 'Telugu' },
  { label: 'Thai', value: 'Thai' },
  { label: 'Tibetan', value: 'Tibetan' },
  { label: 'Turkish', value: 'Turkish' },
  { label: 'Tulu', value: 'Tulu' },
  { label: 'Twi', value: 'Twi' },
  { label: 'Ukrainian', value: 'Ukrainian' },
  { label: 'Urdu', value: 'Urdu' },
  { label: 'Urdu (Pakistan)', value: 'Urdu (Pakistan)' },
  { label: 'Uzbek', value: 'Uzbek' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'Yiddish', value: 'Yiddish' },
  { label: 'Yoruba', value: 'Yoruba' },
]
